import React, { ReactNode } from 'react';
import { routeConstants } from 'routes';
import { ListTitle, SettingsLayout, SettingsNav, SettingsNavItem } from './components';

interface ISettingsUIProps {
  children?: ReactNode;
}

const SettingsScreenLayout: React.FC = ({ children }: ISettingsUIProps) => (
  <SettingsLayout data-cy="settings-layout">
    <SettingsNav data-cy="settings-navigation">
      <ListTitle>My Profile</ListTitle>
      <SettingsNavItem to={routeConstants.private.settingsAccount}>Account Settings</SettingsNavItem>
      <SettingsNavItem to={routeConstants.private.settingsPaymentMethod}>Payment Settings</SettingsNavItem>
      <SettingsNavItem to={routeConstants.private.settingsNotifications}>Notifications</SettingsNavItem>
    </SettingsNav>

    {children}
  </SettingsLayout>
);

export default SettingsScreenLayout;
